module.exports = __webpack_public_path__ + "media/images/icons/mail-2f4e73e149f97825489bb1d7dc7d1cb9.png";